<template>
	<div class="dashboard-wrapper">
		<!--<trade-form ref="tradeForm"/>-->
		<div class="row medium-gutters">
			<div class="col-12 col-lg-6 col-xl-4">
				<div class="card">
					<div class="card-header">
						Vývoj majetku
						<router-link :to="{ name: 'assets' }" class="btn btn-link">
							<font-awesome-icon icon="external-link-alt" class="dashboard-header-link"/>
						</router-link>
					</div>
					<div class="card-body asset-trends d-flex">
						<asset-trends/>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6 col-xl-4">
				<div class="card">
					<div class="card-header">
						Zloženie majetku
						<router-link :to="{ name: 'assets' }" class="btn btn-link">
							<font-awesome-icon icon="external-link-alt" class="dashboard-header-link"/>
						</router-link>
					</div>
					<div class="card-body card-body-assets-composition pt-5 p-lg-2">
						<assets-composition
								:inline="false"
								:selectable="true"
								:onSelect="this.onSelect"
						/>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6 col-xl-4">
				<div class="card">
					<div class="card-header">
						Transakcie
						<router-link :to="{ name: 'transactions' }" class="btn btn-link">
							<font-awesome-icon icon="external-link-alt" class="dashboard-header-link"/>
						</router-link>
					</div>
					<div class="card-body pl-2 pr-2 pt-4">
						<latest-transactions/>
					</div>
				</div>
			</div>
			<div class="col-12 col-sm-12 col-xl-8 order-6 order-xl-5">
				<div class="card p-0">
					<div class="card-body p-0 news-slider">
						<news class="mb-5 mb-xl-0"/>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6 col-xl-4 order-5 order-xl-6">
				<div class="card">
					<div class="card-header">Kontakt</div>
					<div class="card-body p-3">
						<contact-person/>
					</div>
				</div>
			</div>

			<div class="col-12 col-lg-6 col-xl-4 order-7">
				<div class="card">
					<div class="card-header">
						Stav účtov
					</div>
					<div class="card-body pl-2 pr-2 pt-4">
						<cash-states />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import AssetTrends from "../../../components/AssetTrends";
import News from "../../../components/News";
import AssetsComposition from "../../../components/AssetsComposition";
import ContactPerson from "../../../components/ContactPerson";
import LatestTransactions from "../../../components/LatestTransactions";
import TradeForm from "../../../components/form/TradeForm";
import CashStates from "../../../components/CashStates";

export default {
	name: "Dashboard",
	components: {
		CashStates,
		TradeForm,
		LatestTransactions,
		ContactPerson,
		AssetsComposition,
		News,
		AssetTrends
	},
	mounted() {
	},
	methods: {
		onSelect(assetType, assetTypeName) {
		}
	}
};
</script>
<style lang="scss">
.dashboard-wrapper {
	.card-header {
		position: relative;

		.btn-link {
			background: transparent;
			color: #fff;
			font-size: 13px;
			position: absolute;
			top: 5px;
			right: 5px;
		}
	}

	.card-body {
		@include media-breakpoint-only(xl) {
			height: 284px;
		}
		@include media-breakpoint-only(lg) {
			height: 294px;
		}

		&.asset-trends {
			@include media-breakpoint-up(xl) {
				//height: 255px;
			}
		}

		&.news-slider {
			@include media-breakpoint-up(lg) {
				height: 330px !important;
			}

			@include media-breakpoint-down(lg) {
				height: 400px !important;
			}

			@include media-breakpoint-down(sm) {
				height: 250px !important;
			}
		}

		&.card-body-assets-composition {
			display: flex;
			align-items: center;
		}
	}
}
</style>
